import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import UserMenu from './UserMenu';
import './AppHeader.css';

const AppHeader = ({
  viewMode,
  onViewChange,
  onGenerate,
  onSynthesize,
  isProcessing,
  processingMessage,
  onLoginClick,
  onMyChartsClick,
  onDeleteAccount,
  currentChartName,
  onChartNameChange,
  onRenameChart,
}) => {
  const { currentUser } = useAuth();
  const [originalTitle, setOriginalTitle] = useState('');

  const handleTitleBlur = () => {
    if (originalTitle && currentChartName && originalTitle !== currentChartName) {
      if (currentChartName.trim() === '') {
        onChartNameChange(originalTitle);
      } else {
        onRenameChart(currentChartName);
      }
    }
  };

  const handleTitleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.target.blur();
    } else if (e.key === 'Escape') {
      onChartNameChange(originalTitle);
      e.target.blur();
    }
  };

  const renderActionButton = () => {
    const buttonClass = "generateButtonHeader";
    const textToFlow = (
      <button className={buttonClass} onClick={onGenerate} disabled={isProcessing}>
        {isProcessing ? (processingMessage || '処理中...') : 'フローチャートに変換'}
      </button>
    );
    const flowToText = (
      <button className={buttonClass} onClick={onSynthesize} disabled={isProcessing}>
        {isProcessing ? (processingMessage || '処理中...') : '文章に変換'}
      </button>
    );
    return viewMode === 'text' ? textToFlow : viewMode === 'flow' ? flowToText : null;
  };

  return (
    <header className="appHeader">
      <div className="headerLeft">
        <h1 className="appTitle">FlowText</h1>
        {currentChartName !== null && (
          <>
            <input
              type="text"
              value={currentChartName}
            onFocus={() => setOriginalTitle(currentChartName)}
              onChange={(e) => onChartNameChange(e.target.value)}
            onBlur={handleTitleBlur}
            onKeyDown={handleTitleKeyDown}
              className="chart-title-input"
              placeholder="チャート名"
            />
          </>
        )}
      </div>
      <div className="headerCenter">
        <div className="viewSwitcher">
          <button
            className={`switchButton ${viewMode === 'text' ? 'active' : ''}`}
            onClick={() => onViewChange('text')}
          >
            文章
          </button>
          <button
            className={`switchButton ${viewMode === 'flow' ? 'active' : ''}`}
            onClick={() => onViewChange('flow')}
          >
            フローチャート
          </button>
        </div>
      </div>
      <div className="headerRight">
        {renderActionButton()}
        <div className="separator"></div>
        {currentUser ? (
          <UserMenu onMyChartsClick={onMyChartsClick} onDeleteAccount={onDeleteAccount} />
        ) : (
          <button className="generateButtonHeader" onClick={onLoginClick}>
            ログイン / 新規登録
          </button>
        )}
      </div>
    </header>
  );
};

export default AppHeader;
